import React from "react";
import PropTypes from "prop-types";

const buttonStyle =
  "px-6 py-3 rounded-lg transition duration-200 font-medium w-55";

function SuccessMessage({ copy, onReset }) {
  return (
    <div className="text-center space-y-6">
      <h2 className="text-2xl font-bold text-white">{copy.success.title}</h2>
      <p>{copy.success.message}</p>
      <button
        onClick={onReset}
        className={`${buttonStyle} bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white cursor-pointer`}
      >
        {copy.buttons.newSubmission}
      </button>
    </div>
  );
}

SuccessMessage.propTypes = {
  copy: PropTypes.shape({
    success: PropTypes.shape({
      title: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
    }).isRequired,
    buttons: PropTypes.shape({
      newSubmission: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onReset: PropTypes.func.isRequired,
};

export default React.memo(SuccessMessage);
